export const CART_PAGE_CONFIGURATION_QUERY = `
query CartPageQuery {
  aggregatedConfiguration {
    cartConfiguration {
      data{
        serviceSettings {
              id
              name
              isActive
              groupName
              sortOrder
              info
              productCode
              orderPerDay
              stockLimit
              stock
              colorCode
              colorIcon
              image
              price
              vat
          }
          settings {
              id
              name
              value
          }
      }
      messages
    }
    deliveryConfiguration {
      data {
        freeDeliveryEnabled
        freeDeliveryGlobalLimit
        freeDeliveryGlobalFrom
        freeDeliveryGlobalTo
        deliveryFeatures {
          id
          name
          value
        }
        deliveryType {
          deliveryTypeId
          priceLimit
        }
      }
      messages
    }
    paymentConfiguration {
      data {
        payPal {
          clientId
          expressCheckout
        }
        adyen {
          clientKey
          merchantAccount
          applePayMerchantId
          applePayMerchantName
          googlePayEnvironment
          googlePayMerchantName
          googlePayMerchantAccountName
          googlePayMerchantId
        }
      }
      messages
    }
    benefitConfiguration {
        data {
            freeDeliverySettings {
                countryOptions {
                    minimalOrderPriceThreshold
                    orderPriceActivationThreshold
                }
                supportedCountries
            }
        }
    }
  }
}
`;
